import { OptionPriceSuggestionInput } from './option-price-input'

export class OptionPriceProperties {
  /**
   * Ne garde que les attributs attendus par l'API et retire les âges vides,
   * le produit passé par l'appelant contenant bien plus de champs.
   */
  static getSuggestionQuery(input: OptionPriceSuggestionInput): OptionPriceSuggestionInput {
    const { countryId, formulaId, minAge, maxAge } = input

    return {
      countryId,
      formulaId,
      ...(typeof minAge === 'number' && { minAge }),
      ...(typeof maxAge === 'number' && { maxAge })
    }
  }
}
